import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import supportActions from './actions-support'
import getters from './getters'
import mutations from './mutations'
import state from './state'

Vue.use(Vuex)

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions: {
    ...actions,
    ...supportActions,
  },
  modules: {},
})
